// Fallback UI texts shared by the small signup forms that have no Strapi-managed
// error message (footer newsletter, quiz). Keyed by site locale.
const SUBMIT_ERROR_TEXT = {
  cs: 'Něco se pokazilo. Zkuste to znovu.',
  en: 'Something went wrong. Please try again.',
  pl: 'Coś poszło nie tak. Spróbuj ponownie.'
};

export const getSubmitErrorText = (locale) => SUBMIT_ERROR_TEXT[locale] || SUBMIT_ERROR_TEXT.cs;
